import { CaseFlow } from '@gql'
import { defineMessages, type IntlShape } from 'react-intl'

export const caseFlowMessages = defineMessages({
  directAssign: {
    defaultMessage: 'Direct assign',
    description: 'case flow name',
  },
  onResponseAssign: {
    defaultMessage: 'Assign on response',
    description: 'case flow name',
  },
  onScreenedAssign: {
    defaultMessage: 'Assign after screening',
    description: 'case flow name',
  },
})

export function translateCaseFlow(intl: IntlShape, flow: CaseFlow): string {
  switch (flow) {
    case CaseFlow.DIRECT_ASSIGN:
      return intl.formatMessage(caseFlowMessages.directAssign)
    case CaseFlow.ON_RESPONSE_ASSIGN:
      return intl.formatMessage(caseFlowMessages.onResponseAssign)
    case CaseFlow.ON_SCREENED_ASSIGN:
      return intl.formatMessage(caseFlowMessages.onScreenedAssign)
  }
}
